import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SubSink } from 'subsink2';
import { AppConfig } from '../../visa';

@Component({
  selector: 'app-credit-terms',
  templateUrl: './credit-terms.component.html',
  styleUrls: ['./credit-terms.component.css']
})
export class CreditTermsComponent implements OnInit, OnDestroy {

  @Input() creditTerms: FormControl;
  @Output() creditTermsChange = new EventEmitter<FormControl>();

  private subs = new SubSink();

  apiVisa = AppConfig.apiVisa;
  filterControl = new FormControl();

  constructor() {}

  ngOnInit() {
  }

  filterCurrency(search: string) {
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
